"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M33.191 5.113L1.8 14.478a.5.5 0 0 0-.08.926l7.92 3.954zM13.089 21.032l11.937 6a1 1 0 0 0 1.344-.446l9.266-20.222zM10.08 23.25v7.639a.713.713 0 0 0 1.174.544l5.36-4.516z" })
);

